import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AmcfTabCoordinatorService, SUPERSEDED_TAB_MESSAGE } from '@core/amcf-tab-coordinator';
import { captureSsoCallerDevFromReferrer } from '@core/utils/url.utils';
import { environment } from '@environments/environment';
import { ConnectivityAlertModalComponent } from '@shared/connectivity-alert-modal/connectivity-alert-modal.component';
import { ToastHostComponent } from '@shared/toast-host/toast-host.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastHostComponent, ConnectivityAlertModalComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css'
})
export class App implements OnInit {
  private readonly title = inject(Title);
  readonly tabCoordinator = inject(AmcfTabCoordinatorService);
  readonly supersededTabMessage = SUPERSEDED_TAB_MESSAGE;

  ngOnInit(): void {
    this.title.setTitle(environment.PAGE_TITLE);

    captureSsoCallerDevFromReferrer();

    if (this.tabCoordinator.isSuperseded()) {
      return;
    }
  }
}
